$(document).ready(function () {
  const styleMap = Object.fromEntries(
    variantOptions.map((option) => [
      `${option.tag.toLowerCase()}-radio`,
      [
        `#${option.tag.toLowerCase()}-inputs`,
        `.${option.tag.toLowerCase()}-preview-container`,
      ],
    ])
  );

  function updatePreview() {
    const $input = $(this);
    const previewSelector = $input.data("preview");
    const $preview = $(previewSelector);
    const value = $input.val();

    // Special handling for initials
    if (previewSelector.includes("-initial")) {
      $preview.text(value.charAt(0).toUpperCase()); // Only take first character
    } else {
      $preview.text(value);
    }

    // Dynamic font sizing
    if ($input.data("dynamic-font")) {
      const $container = $preview.parent(); // This is the element with --base-size
      const containerWidth = $container.width();
      const viewportWidth = window.innerWidth;

      // Get value from CSS first, then fallback to data attribute
      const cssBaseSize = $container.css("--base-size");
      const cssMinSize = parseFloat($container.css("--min-size"));
      const cssMinusWidth = parseFloat($container.css("--minus-width"));
      const cssPrefLength = parseFloat($container.css("--pref-length"));
      const cssBreakPointLength = parseFloat(
        $container.css("--break-point-length")
      );
      const cssResizeMultiplier = parseFloat(
        $container.css("--resize-multiplier")
      );
      const baseSize = cssBaseSize
        ? parseFloat(cssBaseSize)
        : $input.data("base-size") || containerWidth * 0.13;
      const dataMinSize = parseInt($input.data("min-size"), 10);
      const minSize = !isNaN(cssMinSize) // First check valid CSS value
        ? cssMinSize
        : !isNaN(dataMinSize) // Then check data attribute
        ? dataMinSize
        : 44;
      const minusWidth = !isNaN(cssMinusWidth) ? cssMinusWidth : 0;
      const resizeMultiplier = !isNaN(cssResizeMultiplier)
        ? cssResizeMultiplier
        : 2;
      const prefLength = !isNaN(cssPrefLength)
        ? value.length <= cssPrefLength
          ? value.length
          : value.length * resizeMultiplier
        : value.length;
      const lengthFactor = previewSelector.includes("-line3") ? 3 : 2;

      const newSize = baseSize - minusWidth - prefLength * lengthFactor;
      const breakPoint =
        !isNaN(cssBreakPointLength) && value.length <= cssBreakPointLength
          ? baseSize
          : newSize;

      const newBreakPoint =
        viewportWidth < 430
          ? breakPoint * 0.55
          : viewportWidth < 1200
          ? breakPoint * 0.5
          : breakPoint;
      const newMinSize = viewportWidth < 1200 ? minSize * 0.55 : minSize;

      $preview.css("font-size", Math.max(newBreakPoint, newMinSize) + "px");

      if (!$preview.data("line-height-adjusted")) {
        const currentLineHeight = parseFloat($preview.css("line-height"));
        const newLineHeight =
          viewportWidth < 430
            ? currentLineHeight * 0.6
            : viewportWidth < 1200
            ? currentLineHeight * 0.5
            : currentLineHeight;
        $preview.css("line-height", newLineHeight + "px");
        $preview.data("line-height-adjusted", true); // Mark as adjusted
      }
    } else {
      const viewportWidth = window.innerWidth;
      if (viewportWidth < 1200 && !$preview.data("font-adjusted")) {
        // Get current font size and reduce it by 55%
        const currentSize = parseFloat($preview.css("font-size"));
        $preview.css("font-size", currentSize * 0.55 + "px");
        $preview.data("font-adjusted", true);
      }
    }
  }

  // Event delegation for all preview inputs
  $(".input-fields").on("input", "[data-preview]", updatePreview);

  if (isMultipleDesign) {
    $(".input-fields, .preview-container").hide();
    $("#select-design-label").show();
  } else {
    // $(`#${designTag}-inputs`).show();
  }

  $(document)
    .on("click", 'input[name="properties[Style]"]', function () {
      $(".input-fields, .preview-container").hide();
      const selectedStyle = $(this).attr("id").toLowerCase();

      if (styleMap[selectedStyle]) {
        styleMap[selectedStyle].forEach((selector) => $(selector).fadeIn());
      }
    })
    .on("change", 'input[name="properties[Style]"]', function () {
      $(".input-fields, .preview-container").hide();
      const selectedStyle = $(this).attr("id").toLowerCase();

      styleMap[selectedStyle].forEach((selector) => $(selector).fadeIn());
      $("ul.product__media-list li.is-active").removeClass("is-active");
      $("ul.product__media-list li.template-preview").addClass("is-active");
    })
    .on("click", '.input-fields input[type="text"]', function () {
      $("ul.product__media-list li.is-active").removeClass("is-active");
      $("ul.product__media-list li.template-preview").addClass("is-active");
    });

  $("#custom-inputs-container").on("input", "[data-preview]", updatePreview);

  if (isMultipleDesign) {
    $(".input-fields, .preview-container").hide();
    $("#select-design-label").show();
  }
});
